module.exports = __webpack_public_path__ + "img/home-right.95f6a357.svg";